import { DialogContent, SxProps, Theme } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { FC, PropsWithChildren } from 'react';

interface ICustomDialogContent {
  sx?: SxProps<Theme>;
}

export const CustomDialogContent: FC<
  PropsWithChildren<ICustomDialogContent>
> = ({ sx, children }) => {
  const isDesktop = useIsDesktop();

  return (
    <DialogContent
      sx={{
        padding: isDesktop ? '24px 64px 16px' : '10px 20px',
        marginTop: '24px',
        height: isDesktop ? undefined : '70vh',
        zIndex: '1',
        overflowY: 'auto',
        ...sx,
      }}
    >
      {children}
    </DialogContent>
  );
};
